import { Component, OnDestroy, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { PersonSelectorService } from "../../../../personselector/personselector.service";
import { DataService_TopicMaintenance } from "../../shared/data.service";
import { PersonLoadInfo } from "../../shared/person-load-info";
import { LoadPersonRequest } from "../../shared/load-person-request";
import { PanicAlertTopicRequest } from "../../shared/panic-alert-topic-request";

@Component({
	selector: "app-panic-alert-person-assign",
	templateUrl: "./panic-alert-person-assign.component.html",
	styleUrls: ["./panic-alert-person-assign.component.css"],
})
export class PanicAlertPersonAssignComponent implements OnInit, OnDestroy {
	constructor(
		private personService: PersonSelectorService,
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		private dataService: DataService_TopicMaintenance
	) {}

	ngOnInit(): void {
		this.SelectedSchool = this.dialogConfig.data.SelectedSchool;
		this.SelectedPortalPanicAlertTopic = this.dialogConfig.data.SelectedPortalPanicAlertTopic;

		this.TopicCD = this.SelectedPortalPanicAlertTopic.TopicCD;

		this.PersonSubscription = this.personService.onSelectedMultiplePersons().subscribe((lstPersonIDs) => {
			this.onAddToGroup(lstPersonIDs);
		});
	}

	ngOnDestroy() {
		this.PersonSubscription.unsubscribe();
	}

	/////////////////////////////////////////////////////////////////////
	// Data
	/////////////////////////////////////////////////////////////////////

	PersonSubscription: any;

	SelectedSchool: any;
	SelectedPortalPanicAlertTopic: any;

	TopicCD: string = "";

	SelectStaffExpand: boolean = true;
	StaffToAddExpand: boolean = false;

	lstPersonToAdd: PersonLoadInfo[] = []; //Students from selector
	lstPerson: any = [];

	loading: boolean = false;
	Processing: boolean = false;
	errorMessage: string = "";

	/////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////
	// Load Data
	/////////////////////////////////////////////////////////////////////

	loadPersonInfo() {
		this.errorMessage = "";

		//Get list of students that haven't been loaded
		var lstToLoad: number[] = [];

		//Start from end and take non-loaded entries that were added recently
		for (var z = this.lstPersonToAdd.length - 1; z >= 0; z--) {
			var next = this.lstPersonToAdd[z];

			if (next.Loaded == false) {
				lstToLoad = [...lstToLoad, next.PersonID];
				next.Loaded = true;
			} else {
				break; //Hit end of non-loaded entries (New ones get added to end of list)
			}
		}

		if (lstToLoad.length == 0) {
			return;
		}

		this.loading = true;

		let parms: LoadPersonRequest = {
			lstPersonIDs: lstToLoad,
		};

		//
		// Call WS
		//

		var result = this.dataService.AssignPersonSelectList(parms);
		result.subscribe(
			(response: any) => {
				for (var z = 0; z < response.length; z++) {
					var next = response[z];

					var found = false;
					for (var x = 0; x < this.lstPerson.length; x++) {
						var nextPerson = this.lstPerson[x];

						if (next.PersonID == nextPerson.PersonID) {
							found = true;
							break;
						}
					}

					if (!found) {
						this.lstPerson = [...this.lstPerson, next];
					}
				}

				this.StaffToAddExpand = true;

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	/////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////
	// Events
	/////////////////////////////////////////////////////////////////////
	onAddToGroup(lstPersonIDs: number[]) {
		this.errorMessage = "";
		//
		// Go through Person IDs
		//
		for (var z = 0; z < lstPersonIDs.length; z++) {
			var nextID = lstPersonIDs[z];
			// If it's not already in the list, add it
			var found = false;
			for (var x = 0; x < this.lstPersonToAdd.length; x++) {
				var nextPersonInfo = this.lstPersonToAdd[x];
				if (nextID == nextPersonInfo.PersonID) {
					found = true;
				}
			}
			if (!found) {
				var newInfo: PersonLoadInfo = {
					PersonID: nextID,
					Loaded: false, //Not loaded yet
				};
				this.lstPersonToAdd = [...this.lstPersonToAdd, newInfo];
			}
		}
		this.loadPersonInfo();
	}

	onRemoveAll() {
		this.errorMessage = "";
		this.lstPerson = [];
		this.lstPersonToAdd = [];
	}

	onRemovePerson(Person) {
		this.errorMessage = "";
		this.lstPerson = this.lstPerson.filter((p) => p.PersonID != Person.PersonID);
		this.lstPersonToAdd = this.lstPersonToAdd.filter((p) => p.PersonID != Person.PersonID);
	}
	/////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////
	// Buttons
	/////////////////////////////////////////////////////////////////////

	onAdd() {
		var lstPIDs: number[] = [];

		for (var z = 0; z < this.lstPerson.length; z++) {
			var next = this.lstPerson[z];

			lstPIDs = [...lstPIDs, next.PersonID];
		}

		if (lstPIDs.length == 0) {
			this.errorMessage = "Select staff from the selector to assign to the topic";
			this.SelectStaffExpand = true;
			return;
		}

		this.Processing = true;

		let parms: PanicAlertTopicRequest = {
			PortalPanicAlertTopicID: this.SelectedPortalPanicAlertTopic.PortalPanicAlertTopicID,
			SchoolID: -1,
			TopicCD: "",
			TopicDesc: "",
			lstPersonID: lstPIDs,
		};

		var result = this.dataService.PanicAlertTopicAssign(parms);
		result.subscribe(
			(response: any) => {
				this.Processing = false;

				if (response.Success == true) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "addperson",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Topic was assigned successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "addperson",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not assign topic to the staff members: " + response.ErrorMesssage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onClose() {
		this.ref.close(0);
	}

	/////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////
	// Helpers
	/////////////////////////////////////////////////////////////////////

	IsLoading() {
		return this.Processing == true;
	}

	/////////////////////////////////////////////////////////////////////
}
